import api from 'api'
import { WageCoverageScope } from './getJurisdiction'
import { WageRule } from './getRule'

type CreateRuleRequest = {
  effectiveStart: string
  effectiveEnd?: string | null
  coverageScope: WageCoverageScope
  reference?: string | null
  jurisdictionIds?: number[]
}

export const createRule = async (
  request: CreateRuleRequest
): Promise<WageRule> => {
  const response = await api.post<WageRule>('/admin/wage/rules', {
    effectiveStart: request.effectiveStart,
    effectiveEnd: request.effectiveEnd,
    coverageScope: request.coverageScope,
    reference: request.reference,
    jurisdictionIds: request.jurisdictionIds,
  })
  return response.data
}
